<div class="page-header-container">
  <div class="page-title">
    {{ "request.title" | translate }}
  </div>
</div>

<div class="header-buttons-box">
  <button *ngIf="activePartnerFilterCount <= 0" class="btn white-btn text-uppercase" (click)="partnerFilterHandler()">
    {{'request.partnerFilter' | translate}}
  </button>

  <div class="buttons-group-box active-filters-reset" *ngIf="activePartnerFilterCount > 0">
      <div class="btn-group" role="group">
          <button class="btn white-btn text-uppercase" (click)="partnerFilterHandler()">
            <span>{{'request.partnerFilterActive' | translate}}</span>
          </button>
          <button class="btn white-btn" (click)="resetFiltersHandler(FILTERS_RESET_TYPE.OTHER_FILTERS)">
            <span class="active-filters-badge">{{activePartnerFilterCount}}</span>
            <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
          </button>
      </div>
  </div>

  <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
      {{'request.filter' | translate}}
  </button>
  
  <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
      <div class="btn-group" role="group">
          <button class="btn white-btn text-uppercase" (click)="filterHandler()">
              <span>{{'request.filterActive' | translate}}</span>
          </button>
          <button class="btn white-btn" (click)="resetFiltersHandler(FILTERS_RESET_TYPE.ACTIVE_FILTERS)">
            <span class="active-filters-badge">{{activeFilterCount}}</span>
            <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
          </button>
      </div>
  </div>

  <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
    <div class="btn-group" role="group">
      <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)" 
        [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
        <i class="app-icon icon icon-view-list icon-lg me-2"></i>
        <span>{{ "common.listView" | translate }}</span>
      </button>
      <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)" 
        [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
        <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
        <span>{{ "common.cardsView" | translate }}</span>
      </button>
    </div>
  </div>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasFilteredData">
  <no-records-placeholder
      [showNoRecordsHeader]="true"
      [isActiveFilter]="activeFilterCount > 0"
      (clickHereEvent)="resetFiltersHandler()"
  ></no-records-placeholder>
</div>

<request-list-view
  *ngIf="(tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp) && hasFilteredData"
  [requests]="requests"
  [props]="props"
  [viewDetails]="viewDetailsHandler"
></request-list-view>
<request-card-view
  *ngIf="(tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp) && hasFilteredData"
  [requests]="requests"
  [props]="props"
  [viewDetails]="viewDetailsHandler"
></request-card-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
  <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>
